import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=2caf41bc&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=2caf41bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf41bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2caf41bc')) {
      api.createRecord('2caf41bc', component.options)
    } else {
      api.reload('2caf41bc', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=2caf41bc&scoped=true&", function () {
      api.rerender('2caf41bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2R9Yl4BeyUCTb/JS/comp/CookieBox.vue"
export default component.exports